// CWurfData.js
export const CWurfData = {
    rot: {
        label: 'Rot',
        data: [
            0.300, 0.340, 0.400, 0.440, 0.490, 0.540, 0.610,
            0.650, 0.690, 0.728, 0.765, 0.810, 0.930,
            1.050, 1.080, 1.140, 1.160, 1.240, 1.250, 1.270,
            1.350, 1.430, 1.520, 1.570, 1.620, 1.695, 1.770,
            1.899, 2.027, 2.156, 2.284, 2.413, 2.541, 2.670,
            2.799, 2.927, 3.056, 3.184, 3.313, 3.441, 3.570,
            3.700, 3.827, 3.956, 4.084, 4.213, 4.341, 4.470
        ],
        borderColor: 'rgba(255, 0, 0, 1)',
        backgroundColor: 'rgba(255, 0, 0, 0.2)',
        sex: 'female'
    },
    pink: {
        label: 'Pink',
        data: [
            0.270, 0.290, 0.320, 0.350, 0.400, 0.450, 0.520,
            0.545, 0.570, 0.605, 0.640, 0.710, 0.780,
            0.840, 0.920, 1.020, 1.020, 1.070, 1.110, 1.190,
            1.240, 1.310, 1.420, 1.480, 1.540, 1.600, 1.660,
            1.782, 1.904, 2.026, 2.148, 2.270, 2.391, 2.513,
            2.635, 2.757, 2.879, 3.001, 3.123, 3.245, 3.367,
            3.489, 3.610, 3.732, 3.854, 3.976, 4.098, 4.220
        ],
        borderColor: 'rgba(255, 105, 180, 1)',
        backgroundColor: 'rgba(255, 105, 180, 0.2)',
        sex: 'female'
    },
    blau: {
        label: 'Blau',
        data: [
            0.330, 0.350, 0.380, 0.420, 0.445, 0.470, 0.515,
            0.548, 0.580, 0.640, 0.700, 0.750, 0.850,
            0.890, 0.980, 1.020, 1.050, 1.110, 1.160, 1.230,
            1.330, 1.380, 1.540, 1.585, 1.630, 1.695, 1.760,
            1.907, 2.053, 2.200, 2.347, 2.493, 2.640, 2.787,
            2.933, 3.080, 3.227, 3.373, 3.520, 3.667, 3.813,
            3.960, 4.107, 4.253, 4.400, 4.547, 4.693, 4.840
        ],
        borderColor: 'rgba(0, 0, 255, 1)',
        backgroundColor: 'rgba(0, 0, 255, 0.2)',
        sex: 'male'
    },
    gruen: {
        label: 'Grün',
        data: [
            0.320, 0.350, 0.390, 0.460, 0.505, 0.550, 0.570,
            0.605, 0.640, 0.708, 0.775, 0.780, 0.880,
            0.920, 0.980, 1.020, 1.020, 1.100, 1.140, 1.180,
            1.240, 1.320, 1.380, 1.440, 1.500, 1.565, 1.630,
            1.761, 1.892, 2.023, 2.154, 2.285, 2.416, 2.547,
            2.678, 2.809, 2.940, 3.071, 3.202, 3.333, 3.464,
            3.595, 3.726, 3.857, 3.988, 4.119, 4.250, 4.380
        ],
        borderColor: 'rgba(0, 128, 0, 1)',
        backgroundColor: 'rgba(0, 128, 0, 0.2)',
        sex: 'female'
    },
    gelb: {
        label: 'Gelb',
        data: [
            0.330, 0.360, 0.400, 0.450, 0.495, 0.540, 0.570,
            0.610, 0.650, 0.705, 0.760, 0.800, 0.910,
            1.000, 1.010, 1.070, 1.110, 1.160, 1.200, 1.280,
            1.330, 1.430, 1.480, 1.540, 1.600, 1.670, 1.740,
            1.865, 1.990, 2.115, 2.240, 2.365, 2.490, 2.615,
            2.740, 2.865, 2.990, 3.115, 3.240, 3.365, 3.490,
            3.615, 3.740, 3.865, 3.990, 4.115, 4.240, 4.360
        ],
        borderColor: 'rgba(255, 255, 0, 1)',
        backgroundColor: 'rgba(255, 255, 0, 0.2)',
        sex: 'female'
    },
    lila: {
        label: 'Lila',
        data: [
            0.280, 0.300, 0.340, 0.380, 0.420, 0.460, 0.500,
            0.555, 0.610, 0.645, 0.680, 0.760, 0.850,
            0.910, 0.980, 1.020, 1.040, 1.060, 1.100, 1.140,
            1.220, 1.280, 1.330, 1.395, 1.460, 1.520, 1.580,
            1.703, 1.826, 1.949, 2.072, 2.195, 2.318, 2.441,
            2.564, 2.687, 2.810, 2.933, 3.056, 3.179, 3.302,
            3.425, 3.548, 3.671, 3.794, 3.917, 4.040, 4.160
        ],
        borderColor: 'rgba(128, 0, 128, 1)',
        backgroundColor: 'rgba(128, 0, 128, 0.2)',
        sex: 'female'
    },
    orange: {
        label: 'Orange',
        data: [
            0.280, 0.300, 0.330, 0.390, 0.410, 0.430, 0.460,
            0.500, 0.540, 0.575, 0.610, 0.670, 0.800,
            0.880, 0.910, 0.950, 0.990, 1.030, 1.050, 1.070,
            1.190, 1.290, 1.340, 1.425, 1.510, 1.580, 1.650,
            1.764, 1.878, 1.992, 2.105, 2.219, 2.333, 2.447,
            2.560, 2.674, 2.788, 2.902, 3.016, 3.130, 3.243,
            3.357, 3.471, 3.585, 3.699, 3.812, 3.926, 4.040
        ],
        borderColor: 'rgba(255, 165, 0, 1)',
        backgroundColor: 'rgba(255, 165, 0, 0.2)',
        sex: 'male'
    }
};

export const milestones = [];